import { createSlice } from '@reduxjs/toolkit';
import { OMSPROFILE } from '../../API';
import { authenticate } from '../../pages/Auth/authSlice';
import { fetchProfile } from '../../pages/Settings/Profile/profileSlice';
import { logFrontendActivity } from '../General/activityLogger';

export const onboardingslice = createSlice({
    name: 'onboarding',
    initialState: {
        notificationdata: {
            data: {},
            message: "",
            loading: false,
            hasErrors: false
        },
        activation: {
            data: {},
            message: "",
            loading: false,
            hasErrors: false
        },
        verification: {
            data: {},
            notification: { show: false, messageContent: "", messageType: "success" },
            loading: false,
            hasErrors: false
        },
        stripeVerification: {
            data: {},
            notification: { show: false, messageContent: "", messageType: "success" },
            loading: false,
            hasErrors: false
        },
        verifyQZ: {
            notification: { show: false, messageContent: "", messageType: "success" },
            loading: false,
            hasErrors: false
        },

    },

    reducers: {
        fetchUserOnboardingData: (state) => {
            return {
                ...state,
                notificationdata: {
                    loading: true
                }
            }
        },
        fetchUserOnboardingDataSuccess: (state, action) => {
            return {
                ...state,
                notificationdata: {
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    loading: false,
                    hasErrors: false,
                }
            }
        },
        fetchUserOnboardingDataFailure: (state, action) => {
            return {
                ...state,
                notificationdata: {
                    data: {},
                    message: action && action.payload && action.payload.data && action.payload.data.data,
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        postUserAccountActivate: (state) => {
            return {
                ...state,
                activation: {
                    loading: true
                }
            }
        },
        postUserAccountActivateSuccess: (state, action) => {
            return {
                ...state,
                activation: {
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    hasErrors: false,
                }
            }

        },
        postUserAccountActivateFailure: (state, action) => {
            return {
                ...state,
                activation: {
                    data: {},
                    message: action && action.payload && action.payload.data && action.payload.data.message,
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        postUserAccountVerification: (state) => {
            return {
                ...state,
                verification: {
                    loading: true
                }
            }
        },
        postUserAccountVerificationSuccess: (state, action) => {
            return {
                ...state,
                verification: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "success" },
                    loading: false,
                    hasErrors: false,
                }
            }

        },
        postUserAccountVerificationFailure: (state, action) => {
            return {
                ...state,
                verification: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "error" },
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        getStripeUserAccountVerification: (state) => {
            return {
                ...state,
                stripeVerification: {
                    loading: true
                }
            }
        },
        getStripeUserAccountVerificationSuccess: (state, action) => {
            return {
                ...state,
                stripeVerification: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" },
                    loading: false,
                    hasErrors: false,
                }
            }

        },
        getStripeUserAccountVerificationFailure: (state, action) => {
            return {
                ...state,
                stripeVerification: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" },
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        updateQZData: (state) => {
            return {
                ...state,
                verifyQZ: {
                    loading: true
                }
            }
        },
        updateQZDataSuccess: (state, action) => {
            return {
                ...state,
                verifyQZ: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message], messageType: "success" },
                    loading: false,
                    hasErrors: false,
                }
            }

        },
        updateQZDataFailure: (state, action) => {
            return {
                ...state,
                verifyQZ: {
                    notification:{ show: true, messageContent: [action.payload && action.payload.data && action.payload.data.message], messageType: "error" },
                    loading: false,
                    hasErrors: true,
                }
            }
        },
        resetOnboardingNotification: (state, action) => {
            return {
                ...state,                
                activation: {
                    data: {},
                    message: "",
                    loading: false,
                    hasErrors: false
                },
                verification: {
                    notification: { show: false, messageContent: "", messageType: "success" },
                    loading: false,
                    hasErrors: true,
                },
                stripeVerification: {
                    notification: { show: false, messageContent: "", messageType: "success" },
                    loading: false,
                    hasErrors: true,
                }
            }
        }
    }
})
export const { fetchUserOnboardingData, fetchUserOnboardingDataSuccess, fetchUserOnboardingDataFailure
    , postUserAccountActivate, postUserAccountActivateSuccess, postUserAccountActivateFailure,postUserAccountVerification,
    postUserAccountVerificationSuccess, postUserAccountVerificationFailure, getStripeUserAccountVerification,
    getStripeUserAccountVerificationSuccess, getStripeUserAccountVerificationFailure, updateQZData,
    updateQZDataSuccess, updateQZDataFailure, resetOnboardingNotification
     } = onboardingslice.actions;

export const fetchOnboardingData = data => dispatch => {
    dispatch(fetchUserOnboardingData())
    try {
        OMSPROFILE.get('/onboarding-checklist/validate')
            .then(function (response) {
                dispatch(fetchUserOnboardingDataSuccess(response));
            }).catch(function (error) {
                dispatch(fetchUserOnboardingDataFailure(error.response));
            })
    }
    catch (error) {
        dispatch(fetchUserOnboardingDataFailure(error.response))
    }
}
export const useraccountactivate = data => dispatch => {
    dispatch(postUserAccountActivate())
    try {
        OMSPROFILE.post('onboarding-checklist/account-activation')
            .then(function (response) {
                dispatch(postUserAccountActivateSuccess(response));
                dispatch(authenticate());
            }).catch(function (error) {
                dispatch(postUserAccountActivateFailure(error.response));
            })
    }
    catch (error) {
        dispatch(postUserAccountActivateFailure(error.response))
    }
}
export const useraccountVerification = (userid,data) => dispatch => {
    dispatch(postUserAccountVerification())
     const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.post('onboarding-checklist/useraccount-verification',data)
            .then(function (response) {
                dispatch(postUserAccountVerificationSuccess(response));
                dispatch(fetchProfile({ force: true }));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'USER_ACCOUNT_VERIFICATION',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });  
            }).catch(function (error) {
                dispatch(postUserAccountVerificationFailure(error.response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'USER_ACCOUNT_VERIFICATION',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            })
    }
    catch (error) {
        dispatch(postUserAccountVerificationFailure(error.response))
        logFrontendActivity({
            group: 'ONBOARDING',
            subgroup: 'USER_ACCOUNT_VERIFICATION',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        }); 
    }
}
export const stripeuseraccountVerification = (userid,data) => dispatch => {
    dispatch(getStripeUserAccountVerification())
    const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.get('onboarding-checklist/stripe-check-verification/'+data)
            .then(function (response) {
                dispatch(getStripeUserAccountVerificationSuccess(response));
                dispatch(fetchProfile({ force: true }));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'STRIPE_USER_ACCOUNT_VERIFICATION',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(getStripeUserAccountVerificationFailure(error.response));
                logFrontendActivity({
                    group: 'ONBOARDING',
                    subgroup: 'STRIPE_USER_ACCOUNT_VERIFICATION',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            })
    }
    catch (error) {
        dispatch(getStripeUserAccountVerificationFailure(error.response))
        logFrontendActivity({
            group: 'ONBOARDING',
            subgroup: 'STRIPE_USER_ACCOUNT_VERIFICATION',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        }); 
    }
}

export const updateQZ = data => dispatch => {
    dispatch(updateQZData())
    try {
        OMSPROFILE.get('onboarding-checklist/qz-update')
            .then(function (response) {
                dispatch(updateQZDataSuccess(response));
                dispatch(fetchProfile({ force: true }));
            }).catch(function (error) {
                dispatch(updateQZDataFailure(error.response));
            })
    }
    catch (error) {
        dispatch(updateQZDataFailure(error.response))
    }
}

export const resetOnboarding = data => dispatch => {    
    dispatch(resetOnboardingNotification());
}
export default onboardingslice.reducer;
